import React from "react";
import { Layer } from "react-konva";
import { Infrastructures } from "../InfraStructures";
import { EPDTrack } from "../EPDTrack";
import { Location } from "@opstel/query/models/location";
import { TRACK_LINE_WIDTH } from "@opstel/EPD/core/styles";

export interface InfrastructureLayerProps {
  readonly location: Location;
}
export function InfrastructureLayer({ location }: InfrastructureLayerProps): React.JSX.Element {
  return (
    <Layer>
      {location.tracks.map((track) => (
        <EPDTrack key={track.code} track={track} trackLineWidth={TRACK_LINE_WIDTH} />
      ))}
      <Infrastructures location={location} trackLineWidth={TRACK_LINE_WIDTH} />
    </Layer>
  );
}
